import { Box, BoxProps } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import React from 'react'
type Props = {
  children: React.ReactNode
  sx?: SxProps<Theme>
  component?: React.ElementType
} & Omit<BoxProps, 'component'>

export const ContainerCustomV2 = ({ children, sx, component, ...other }: Props) => {
  return (
    <Box component={component || 'div'} className="container px-[10px]"  {...other} sx={sx || {}}>
      {children}
    </Box>
  )
}
